import React from 'react';

const Error500Image = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="400"
    height="195"
    viewBox="0 0 400 195"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M61.4452 192.698C91.2534 192.698 115.418 191.302 115.418 189.58C115.418 187.858 91.2534 186.462 61.4452 186.462C31.637 186.462 7.47266 187.858 7.47266 189.58C7.47266 191.302 31.637 192.698 61.4452 192.698Z"
      fill="#D8D8D8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M173.142 51C177.313 51.8177 181.653 54.7104 185.164 59.091L183.685 69.2638L187.648 62.683C188.108 63.4571 188.543 64.2621 188.95 65.096C192.709 72.8033 193.027 80.9093 190.325 86.2317C186.804 85.5412 183.162 83.3719 180 80.077L186.412 78.3271L177.155 76.6116C176.187 75.2361 175.299 73.7391 174.517 72.1353C172.931 68.8829 171.957 65.5595 171.565 62.4043L178.858 63.2926L171.366 59.014C171.395 56.0905 171.964 53.4099 173.045 51.1936L173.142 51Z"
      fill="#247D70"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M163.653 82.5251C165.504 80.7498 168.175 79.6866 171.11 79.5908L174.597 84.6413L173.513 79.727C174.056 79.8058 174.602 79.9177 175.149 80.0642C179.573 81.2496 182.839 84.3802 183.875 87.9437C181.196 90.5121 176.802 91.5901 172.378 90.4048C170.506 89.9031 168.841 89.0531 167.465 87.9692L170.44 84.7149L166.136 86.7566C164.986 85.5409 164.146 84.1367 163.691 82.6539L163.653 82.5251Z"
      fill="#56CBB9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M218.743 64.8298C220.312 67.6463 220.744 71.222 219.903 74.7883L212.774 77.2786L218.971 77.5891C218.712 78.1874 218.414 78.7796 218.078 79.3618C215.253 84.2562 210.448 87.1325 205.826 87.2035C203.575 83.1652 203.664 77.5656 206.489 72.671C207.684 70.6018 209.232 68.8934 210.971 67.605L213.999 72.2907L212.881 66.3981C214.703 65.4311 216.653 64.8906 218.576 64.8331L218.743 64.8298Z"
      fill="#247D70"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M233.098 82.4448C231.018 80.9444 228.224 80.2633 225.305 80.5768L222.555 86.0635L222.944 81.0462C222.418 81.1998 221.892 81.3867 221.371 81.6078C217.155 83.3973 214.356 86.9521 213.827 90.625C216.837 92.7957 221.338 93.2516 225.554 91.4621C227.338 90.7048 228.869 89.6313 230.081 88.3665L226.682 85.5578L231.228 86.9806C232.197 85.6168 232.834 84.1092 233.078 82.5776L233.098 82.4448Z"
      fill="#56CBB9"
    />
    <path d="M179.203 86.2382L187.232 88.4654L190.801 94.2561" stroke="#0D5147" strokeWidth="0.5" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M205.401 55.3034C207.928 58.14 209.404 62.3509 209.465 67.0466L202.47 72.6995L209.228 70.721C209.106 71.5894 208.937 72.4659 208.717 73.3456C206.949 80.4367 202.424 85.8299 197.319 87.7188C193.698 83.6541 192.234 76.7677 194.002 69.6766C194.774 66.5799 196.072 63.8069 197.715 61.5083L202.436 66.1185L199.534 59.3004C201.238 57.5106 203.179 56.1628 205.217 55.3731L205.401 55.3034Z"
      fill="#56CBB9"
    />
    <path d="M219.794 89.3564L211.765 91.1382L209.535 94.2563" stroke="#0D5147" strokeWidth="0.5" />
    <path d="M188.125 81.7838L191.693 87.5745L192.585 93.8106" stroke="#0D5147" strokeWidth="0.5" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M74.5036 123.21H82.9787L62.9063 189.997H59.7839L74.5036 123.21Z"
      fill="#8D5219"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M83.8709 123.21L63.7984 189.997H62.0142L82.0867 123.21H83.8709Z"
      fill="#7C4612"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M97.1295 123.683H88.6545L108.727 190.471H111.849L97.1295 123.683Z"
      fill="#8D5219"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M97.1294 123.683L111.849 190.471H110.065L95.3452 123.683H97.1294Z"
      fill="#7C4612"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M60.5532 121.986L111.724 118.179L112.035 122.913L60.8643 126.72L60.5532 121.986Z"
      fill="#AB6C2C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M107.275 118.51L111.724 118.179L112.035 122.913L107.586 123.244L107.275 118.51Z"
      fill="#824D18"
    />
    <path d="M198.83 82.6747L197.492 87.5746V93.8108" stroke="#0D5147" strokeWidth="0.5" />
    <path d="M208.197 83.5657L205.967 87.1292L204.628 94.7017" stroke="#0D5147" strokeWidth="0.5" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M185.447 93.8109H212.212C213.936 93.8109 215.334 95.2083 215.334 96.9321V115.626C215.334 122.028 210.143 127.219 203.741 127.219H193.919C187.516 127.219 182.326 122.028 182.326 115.626V96.9321C182.326 95.2083 183.723 93.8109 185.447 93.8109Z"
      fill="#5A93A0"
      fillOpacity="0.21"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M212.213 93.8109C213.936 93.8109 215.334 95.2083 215.334 96.9321V115.626C215.334 122.028 210.143 127.219 203.741 127.219H200.172C206.575 127.219 211.765 122.028 211.765 115.626V96.9321C211.765 95.2083 210.368 93.8109 208.644 93.8109H212.213Z"
      fill="#F2F2F2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M165.421 129H173.851L154.357 190.327C154.076 191.208 153.258 191.807 152.333 191.807C151.653 191.807 151.101 191.255 151.101 190.575C151.101 190.48 151.112 190.386 151.133 190.295L165.421 129Z"
      fill="#8D5219"
    />
    <path
      d="M192.585 194.925C222.393 194.925 246.558 193.031 246.558 190.693C246.558 188.356 222.393 186.462 192.585 186.462C162.777 186.462 138.612 188.356 138.612 190.693C138.612 193.031 162.777 194.925 192.585 194.925Z"
      fill="#D8D8D8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.78456 60.5013L51.4444 60.4052C54.0422 60.3997 56.3263 62.1233 57.0339 64.6228L77.206 135.879C78.078 138.959 76.2879 142.163 73.2076 143.035C72.6939 143.181 72.1625 143.255 71.6287 143.255H10.4947C7.44163 143.255 4.91192 140.886 4.71079 137.84L0.0128079 66.6797C-0.198086 63.4853 2.22052 60.7248 5.4149 60.5139C5.53796 60.5058 5.66124 60.5016 5.78456 60.5013Z"
      fill="#FEB63B"
    />
    <path
      d="M98.9145 136.573H7.02583C5.79454 136.573 4.79639 137.571 4.79639 138.802V149.488C4.79639 150.719 5.79454 151.717 7.02583 151.717H98.9145C100.146 151.717 101.144 150.719 101.144 149.488V138.802C101.144 137.571 100.146 136.573 98.9145 136.573Z"
      fill="#FFC055"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.3152 124.546H30.7903L10.7178 191.334H7.59546L22.3152 124.546Z"
      fill="#8D5219"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.6823 124.546L11.6099 191.334H9.82568L29.8981 124.546H31.6823Z"
      fill="#7C4612"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.9411 125.02H36.4661L56.5385 191.807H59.6609L44.9411 125.02Z"
      fill="#8D5219"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.9412 125.02L59.661 191.807H57.8768L43.157 125.02H44.9412Z"
      fill="#7C4612"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.36475 123.323L59.536 119.516L59.8471 124.25L8.6759 128.057L8.36475 123.323Z"
      fill="#AB6C2C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M55.0864 119.847L59.536 119.516L59.8472 124.25L55.3975 124.581L55.0864 119.847Z"
      fill="#824D18"
    />
    <path
      d="M346.028 192.698C316.219 192.698 292.055 191.302 292.055 189.58C292.055 187.858 316.219 186.462 346.028 186.462C375.836 186.462 400 187.858 400 189.58C400 191.302 375.836 192.698 346.028 192.698Z"
      fill="#D8D8D8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M320.926 123.21H312.451L332.523 189.997H335.645L320.926 123.21Z"
      fill="#8D5219"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M311.559 123.21L331.631 189.997H333.415L313.343 123.21H311.559Z"
      fill="#7C4612"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M298.3 123.683H306.775L286.702 190.471H283.58L298.3 123.683Z"
      fill="#8D5219"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M298.3 123.683L283.58 190.471H285.364L300.084 123.683H298.3Z"
      fill="#7C4612"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M334.876 121.986L283.705 118.179L283.394 122.913L334.565 126.72L334.876 121.986Z"
      fill="#AB6C2C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M288.155 118.51L283.705 118.179L283.394 122.913L287.844 123.244L288.155 118.51Z"
      fill="#824D18"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M379.832 60.5013L334.172 60.4052C331.574 60.3997 329.29 62.1233 328.582 64.6228L308.41 135.879C307.538 138.959 309.328 142.163 312.408 143.035C312.922 143.181 313.454 143.255 313.987 143.255H375.121C378.174 143.255 380.704 140.886 380.905 137.84L385.603 66.6797C385.814 63.4853 383.396 60.7248 380.201 60.5139C380.078 60.5058 379.955 60.5016 379.832 60.5013Z"
      fill="#FEB63B"
    />
    <path
      d="M286.702 136.573H378.59C379.821 136.573 380.82 137.571 380.82 138.802V149.488C380.82 150.719 379.821 151.717 378.59 151.717H286.702C285.47 151.717 284.472 150.719 284.472 149.488V138.802C284.472 137.571 285.47 136.573 286.702 136.573Z"
      fill="#FFC055"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M310.028 135.803C313.411 141.674 317.666 143.94 317.666 143.94H335.366C335.366 143.94 307.448 131.327 310.028 135.803Z"
      fill="#233862"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M323.622 181.221C324.083 181.747 324.144 182.337 323.915 182.965C323.915 182.967 323.913 182.971 323.911 182.973C323.488 184.137 322.093 185.435 320.472 186.733C320.266 186.899 320.081 187.051 319.921 187.191C319.879 187.227 319.836 187.265 319.798 187.301C319.764 187.331 319.734 187.361 319.702 187.387C318.191 188.775 318.761 189.093 316.047 191.912C312.951 195.122 310.821 195.18 310.215 194.888C309.701 194.638 310.742 192.936 311.898 191.022C311.954 190.93 312.008 190.836 312.067 190.744C312.219 190.488 312.373 190.23 312.526 189.974C313.878 187.671 313.531 186.591 313.21 183.163C312.949 180.377 308.863 167.602 308.863 167.602L314.795 166.582C314.795 166.582 316.58 176.757 318.548 178.323C319.6 179.159 320.779 179.169 321.79 179.787C321.861 179.831 321.931 179.875 321.999 179.921C322.575 180.301 323.161 180.693 323.622 181.221Z"
      fill="#FFB27D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M323.622 181.221C324.083 181.747 324.144 182.337 323.915 182.965C323.915 182.967 323.913 182.971 323.911 182.973C323.393 184.135 322.033 185.427 320.468 186.721C320.264 186.891 320.083 187.045 319.921 187.191C319.879 187.227 319.836 187.265 319.798 187.301C319.764 187.331 319.734 187.361 319.702 187.387C318.191 188.775 318.761 189.093 316.047 191.912C312.951 195.122 310.821 195.18 310.215 194.888C309.701 194.638 310.742 192.936 311.898 191.022C312.5 190.802 315.298 189.668 317.415 186.969C319.279 184.599 320.52 181.553 321.79 179.787C321.861 179.831 321.931 179.875 321.999 179.921C322.575 180.301 323.161 180.693 323.622 181.221Z"
      fill="#233862"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M275.801 177.527C275.434 179.353 272.824 179.049 269.909 178.337C266.994 177.627 267.686 178.473 263.537 178.015C259.389 177.557 258.131 176.012 258.004 175.398C257.892 174.852 259.942 174.66 262.141 174.408C262.418 174.376 262.695 174.342 262.974 174.308C265.455 173.998 267.273 172.4 269.53 171.088C271.666 169.846 274.854 164.784 274.854 164.784L280.544 165.232C280.544 165.232 277.559 169.754 276.403 171.72C275.723 172.876 275.759 174.406 275.843 175.586C275.887 176.229 275.93 176.885 275.801 177.527Z"
      fill="#FFB27D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M269.909 178.337C266.994 177.627 267.686 178.473 263.537 178.015C259.389 177.557 258.131 176.012 258.004 175.398C257.892 174.852 259.942 174.66 262.141 174.408L262.161 174.45C262.161 174.45 264.649 176.208 268.103 176.29C270.918 176.358 273.899 175.554 275.843 175.586C275.887 176.228 275.929 176.885 275.801 177.527C275.434 179.353 272.824 179.049 269.909 178.337Z"
      fill="#233862"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M297.608 141.25L309.872 174.156C309.872 174.156 311.756 174.336 313.561 173.82C315.222 173.34 317.13 172.088 317.13 172.088C317.13 172.088 315.2 152.081 311.603 140.596C310.682 137.647 309.649 135.263 308.508 133.919C302.933 127.349 297.608 141.25 297.608 141.25Z"
      fill="#233862"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M303.017 118.586C306.501 117.466 316.44 118.904 326.425 120.852L328.515 117.414L350.083 115.736C350.083 115.736 357.199 131.471 353.303 141.496C352.729 142.97 351.592 143.914 349.652 143.946C349.652 143.946 349.339 143.946 349.337 143.946C349.337 143.946 336.502 143.938 332.335 143.938C321.608 143.938 309.635 136.587 308.086 136.279C305.551 135.773 304.537 140.83 302.002 146.136C299.466 151.445 278.17 169.644 278.17 169.644C278.17 169.644 274.898 169.676 273.546 169.17C272.092 168.626 271.56 167.92 271.56 167.92C271.56 167.92 295.157 121.114 303.017 118.586Z"
      fill="#2B478B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M329.364 54.8051C332.126 53.3582 336.331 53.1626 337.013 53.0712C345.186 51.9763 350.105 63.8158 350.394 67.4041C350.928 74.0166 354.437 75.0247 359.374 79.165C369.276 87.4697 366.373 97.1184 360.959 100.703C357.709 102.855 351.983 100.703 351.983 100.703C351.903 100.759 336.323 92.02 328.643 87.8037C317.13 86.1716 322.324 58.4914 329.364 54.8051Z"
      fill="#233862"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M335.079 84.2154C335.045 84.2374 338.859 85.5335 341.407 84.4094C343.806 83.3514 345.622 79.4191 345.587 79.4171C344.496 79.3671 343.298 78.415 342.376 72.1745L341.91 72.3425L334.1 75.1447C334.1 75.1447 334.666 77.6429 335.033 80.0211C335.34 82.0193 335.506 83.9334 335.079 84.2154Z"
      fill="#FFB27D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M334.1 75.1447C334.1 75.1447 334.666 77.6429 335.033 80.0211C339.519 79.217 341.28 74.7607 341.91 72.3425L334.1 75.1447Z"
      fill="#ED975D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M332.937 77.6249C332.937 77.6249 343.623 76.1928 342.628 69.5723C341.633 62.9518 342.342 58.3074 335.476 58.9395C328.611 59.5735 327.668 62.2977 327.462 64.5879C327.255 66.8781 330.132 77.8249 332.937 77.6249Z"
      fill="#FFB27D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M327.851 60.9596C327.851 60.9596 334.692 66.8361 339.344 67.3101C343.999 67.7842 345.76 66.294 345.76 66.294C345.76 66.294 343.018 64.0239 341.367 60.3596C340.881 59.2795 339.852 58.5395 338.668 58.4374C335.346 58.1514 329.049 58.0214 327.851 60.9596Z"
      fill="#233862"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M332.126 60.4316C332.126 60.4316 329.839 62.6377 329.117 64.2739C328.423 65.854 328.214 69.6303 328.768 71.1304C328.768 71.1304 325.201 64.2179 327.221 60.8596C329.361 57.2973 332.126 60.4316 332.126 60.4316Z"
      fill="#233862"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M326.082 99.9106C326.405 121.478 326.17 116.97 328.535 119.018C329.107 119.51 330.71 119.804 332.818 119.942C339.453 120.382 351.113 119.292 351.556 118.07C353.087 113.842 352.005 112.528 353.281 106.053C353.416 105.365 353.58 104.619 353.773 103.807C354.838 99.3606 355.873 97.8485 352.098 90.7039C348.673 84.2334 345.116 78.981 344.795 79.171C335.761 84.5174 335.033 80.0231 335.033 80.0231C335.033 80.0231 325.923 89.3898 326.082 99.9106Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M302.926 155.521L309.872 174.156C309.872 174.156 311.756 174.336 313.561 173.82C315.222 173.34 317.13 172.088 317.13 172.088C317.13 172.088 315.2 152.081 311.603 140.596L302.926 155.521Z"
      fill="#2B478B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M335.033 80.0211C335.033 80.0211 325.736 81.5932 324.645 85.5835C323.554 89.5738 317.13 113.032 317.13 113.032C317.13 113.032 321.854 113.88 324.039 111.703C326.222 109.525 331.635 91.5079 331.635 91.5079L335.033 80.0211Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M332.818 119.942C339.453 120.382 351.112 119.292 351.556 118.07C353.086 113.842 352.005 112.528 353.281 106.053L350.083 97.0704C350.083 97.0704 350.611 107.073 347.654 109.703C344.697 112.334 335.541 114.782 334.102 116.98C333.408 118.036 332.951 119.092 332.818 119.942Z"
      fill="#EBF3FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M340.417 115.736C340.417 115.736 333.873 114.284 332.818 114.862C331.763 115.442 329.183 117.55 328.858 118.284C328.535 119.018 331.209 117.726 332.08 117.494C332.642 117.344 334.126 117.856 334.858 118.1C337.948 119.128 339.84 118.6 339.84 118.6L340.417 115.736Z"
      fill="#FFB27D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M344.801 79.165C344.801 79.165 353.588 79.7051 356.629 83.9354C360.913 89.8899 369.407 115.264 364.538 118.65C359.055 122.46 339.587 119.646 339.587 119.646C339.587 119.646 338.939 116.628 339.84 115.166C340.743 113.706 355.39 111.348 356.066 110.673C356.742 109.999 347.616 97.5285 347.616 95.5063C347.616 93.4841 344.801 79.165 344.801 79.165Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M332.501 116.678C332.501 116.678 331.131 118.442 330.682 118.652C330.232 118.862 329.941 118.81 329.941 118.81L330.864 117.152L332.501 116.678Z"
      fill="#FFB27D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M332.818 114.862L328.832 116.792C328.832 116.792 329.002 117.068 329.492 117.046C329.983 117.024 331.221 116.572 331.221 116.572L332.818 114.862Z"
      fill="#FFB27D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M330.682 121.354H299.147L289.66 97.8345H321.146L330.682 121.354Z"
      fill="#40A1CE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M298.778 120.436H340.417V121.354H299.147L298.778 120.436Z"
      fill="#ED7D2B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M307.107 109.593C306.868 108.767 307.348 108.097 308.179 108.097C309.007 108.097 309.872 108.767 310.11 109.593C310.347 110.419 309.868 111.091 309.039 111.091C308.209 111.091 307.344 110.419 307.107 109.593Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M371.33 124.546H362.855L382.927 191.334H386.049L371.33 124.546Z"
      fill="#8D5219"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M361.963 124.546L382.035 191.334H383.819L363.747 124.546H361.963Z"
      fill="#7C4612"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M348.704 125.02H357.179L337.107 191.807H333.984L348.704 125.02Z"
      fill="#8D5219"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M348.704 125.02L333.984 191.807H335.768L350.488 125.02H348.704Z"
      fill="#7C4612"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M385.28 123.323L334.109 119.516L333.798 124.25L384.969 128.057L385.28 123.323Z"
      fill="#AB6C2C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M338.559 119.847L334.109 119.516L333.798 124.25L338.248 124.581L338.559 119.847Z"
      fill="#824D18"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M154.578 175.771L158.685 177.011L154.385 190.32C154.099 191.206 153.273 191.807 152.341 191.807C151.659 191.807 151.105 191.254 151.105 190.571C151.105 190.475 151.117 190.38 151.139 190.286L154.578 175.771Z"
      fill="#D1A65C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M193.031 129H201.506L198.778 188.911C198.738 189.784 198.019 190.471 197.146 190.471C196.273 190.471 195.556 189.783 195.52 188.911L193.031 129Z"
      fill="#8D5219"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M199.275 177.999L198.795 188.986C198.759 189.817 198.075 190.471 197.245 190.471C196.414 190.471 195.733 189.816 195.699 188.986L195.261 177.999H199.275Z"
      fill="#D1A65C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M229.562 129H221.133L240.627 190.327C240.907 191.208 241.725 191.807 242.65 191.807C243.33 191.807 243.882 191.255 243.882 190.575C243.882 190.48 243.871 190.386 243.85 190.295L229.562 129Z"
      fill="#8D5219"
    />
    <path
      d="M249.457 127.219H143.296C142.68 127.219 142.181 127.718 142.181 128.333V129.222C142.181 129.838 142.68 130.337 143.296 130.337H249.457C250.073 130.337 250.572 129.838 250.572 129.222V128.333C250.572 127.718 250.073 127.219 249.457 127.219Z"
      fill="#A4DDD5"
    />
    <path
      d="M236.968 130.337H157.569C156.954 130.337 156.455 130.836 156.455 131.452V131.895C156.455 132.51 156.954 133.009 157.569 133.009H236.968C237.583 133.009 238.082 132.51 238.082 131.895V131.452C238.082 130.836 237.583 130.337 236.968 130.337Z"
      fill="#75471A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M240.439 176.217L243.847 190.72C243.869 190.813 243.88 190.909 243.88 191.005C243.88 191.694 243.321 192.252 242.632 192.252C241.694 192.252 240.863 191.646 240.577 190.753L236.298 177.399L240.439 176.217Z"
      fill="#D1A65C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M166.782 128H198.468L208 104H176.363L166.782 128Z"
      fill="#2B478B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M198.839 127.065H157V128H198.468L198.839 127.065Z"
      fill="#2B478B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M190.469 116.001C190.709 115.156 190.227 114.472 189.393 114.472C188.56 114.472 187.691 115.156 187.452 116.001C187.214 116.844 187.696 117.528 188.528 117.528C189.363 117.528 190.231 116.844 190.469 116.001Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M114.731 194.903C114.731 194.903 114.276 191.349 113.22 189.236C112.163 187.121 105.445 188.465 105.445 188.465C105.445 188.465 104.102 189.62 103.813 195L114.731 194.903Z"
      fill="#233862"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M137.621 194.854C136.044 193.89 136.941 186.695 136.941 186.695C136.941 186.695 144.297 180.805 145.31 185.315C146.32 189.825 152.297 191.85 155.7 192.402C158.047 192.784 158.775 194.084 159 194.854H137.621Z"
      fill="#233862"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M122.384 142.525C122.684 144.176 122.874 145.532 122.925 146.503C123.608 159.852 134.154 190.379 136.039 191.09C138.957 192.192 143.552 189.85 145.956 189.084C146.953 188.766 147.626 187.759 147.403 186.739C142.182 162.711 140.263 128.113 139.564 107.629C139.211 97.3126 137.442 90.1864 137.442 90.1864C137.442 90.1864 111.725 83.3185 111.572 92.0055C111.438 99.6925 120.09 129.842 122.384 142.525Z"
      fill="#213F7A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M122.384 142.525L139.564 107.629C139.211 97.3126 137.442 90.1864 137.442 90.1864C137.442 90.1864 111.724 83.3185 111.572 92.0055C111.438 99.6925 120.09 129.842 122.384 142.525Z"
      fill="#233862"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M128.106 92.0364L114.512 190.658C114.512 190.658 108.542 192.099 103.899 190.947C103.899 190.947 99.9177 138.494 100.249 125.813C100.582 113.132 97.3923 91.8818 100.976 89.5395C104.561 87.1951 128.106 92.0364 128.106 92.0364Z"
      fill="#213F7A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M98.3275 90.3917C98.2613 91.2836 98.8303 92.0938 99.6883 92.3432C101.585 92.8929 103.771 93.2771 107.988 94.1513C111.949 94.9747 117.278 95.7032 123.825 95.7452C134.24 95.8114 138.181 92.2174 138.181 92.2174C138.631 92.2262 137.945 90.0451 137.327 79.6737C137.118 76.1592 136.917 71.7064 136.772 66.0769C136.639 61.0126 136.551 54.9947 136.542 47.8574C136.531 39.2697 123.251 30.0322 123.006 30.0322L123.004 30.0361C123.004 31.2726 121.056 33.554 118.059 33.7509C114.499 33.9838 110.134 32.2111 110.134 30.1595C110.134 30.1388 103.7 40.4619 101.415 51.4603C100.26 56.9948 100.727 56.8469 98.3275 90.3917Z"
      fill="#B0D0FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M123.006 30.0326C123.006 30.0326 135.356 29.9278 138.327 34.0993C141.298 38.2719 147.813 60.7124 144.414 68.1786C141.013 75.647 134.652 65.0901 131.121 60.5159C127.59 55.9417 123.006 30.0326 123.006 30.0326Z"
      fill="#B0D0FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M123.132 28.1464L123.125 29.424C123.125 29.424 123.474 33.4196 118.557 34.003C113.641 34.5881 109.993 33.2569 110.128 30.1735C110.571 27.7861 110.981 25.3348 111.014 23.3596C111.025 22.6254 110.974 21.8465 110.838 20.967L120.364 20.7765L123.169 21.2352L123.132 28.1464Z"
      fill="#FFB27D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M123.169 21.2352L123.132 28.1464C122.122 28.6171 120.979 28.9045 119.7 28.9045C115.322 28.9045 112.492 25.6913 111.014 23.3596C111.025 22.6254 110.974 21.8465 110.838 20.967L120.364 20.7765L123.169 21.2352Z"
      fill="#E2915A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M110.108 19.4327C111.213 25.386 118.889 25.1904 122.206 24.8162C123.139 24.7123 123.725 24.5931 123.725 24.5931C124.778 24.3118 125.366 22.6525 125.638 20.4794C126.18 16.1782 125.497 9.86466 124.771 8.25001C123.677 5.82007 121.619 3.19212 113.891 5.08825C106.16 6.98592 108.69 11.8052 110.108 19.4327Z"
      fill="#FFB27D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M135.633 46.7558C135.633 46.7558 140.409 57.3127 140.27 60.4784C140.27 60.4784 137.905 60.3967 135.633 61.0745C131.899 62.1871 135.633 46.7558 135.633 46.7558Z"
      fill="#98BAF4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M127.142 2.58346C127.142 2.58346 123.741 2.32142 119.726 0.575187C116.471 -0.841887 112.362 0.718683 111.027 1.42203C111.063 1.20701 111.149 0.913395 111.354 0.618898C111.354 0.618898 110.754 1.04387 110.666 1.63794C110.604 1.68341 110.577 1.71498 110.593 1.72536C110.593 1.72536 109.914 1.60107 109.477 1.79755C109.477 1.79755 109.783 1.75384 109.892 1.95032C109.903 1.97107 109.92 1.98873 109.94 2.0044C104.86 4.46127 104.391 12.4972 106.027 14.3567C107.992 16.5939 110.963 21.6558 110.963 21.6558C110.963 21.6558 111.213 20.4416 110.853 18.4728C110.496 16.5043 112.194 16.5043 114.34 15.6096C116.486 14.7146 114.698 12.2091 116.577 10.6879C118.454 9.1666 125.338 10.0613 125.247 8.89815C127.803 7.96653 127.142 2.84529 127.142 2.58346Z"
      fill="#233862"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M108.553 66.5317C110.569 74.6337 132.371 78.8216 137.327 79.6737C137.118 76.1592 136.917 71.7064 136.772 66.077L108.553 66.5317Z"
      fill="#98BAF4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M113.339 69.1654C113.13 69.1654 108.491 68.4722 107.66 68.0572C106.83 67.6399 103.03 62.2357 105.518 60.8493C108.006 59.4629 114.687 65.0062 114.687 65.0062L113.339 69.1654Z"
      fill="#FFB27D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M141.553 70.7704C141.553 70.7704 123.613 71.7461 111.572 69.1654C111.572 69.1654 111.268 65.684 115.05 64.1364C115.05 64.1364 133.818 60.1561 138.326 61.2643C142.835 62.3725 141.553 70.7704 141.553 70.7704Z"
      fill="#B0D0FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M100.35 56.6769C104.073 61.1716 108.941 64.8407 114.307 65.6994H114.309C114.354 65.631 115.933 63.2291 115.637 59.7013C115.5 58.0677 114.96 56.1934 113.683 54.1955C113.29 53.5818 112.94 52.8643 112.629 52.0673C109.697 44.5835 110.134 30.1595 110.134 30.1595C110.134 30.1595 97.69 31.4638 93.8125 37.0083C91.4371 40.4045 94.4654 49.5727 100.35 56.6769Z"
      fill="#B0D0FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M122.206 24.8162C123.139 24.7123 123.725 24.5931 123.725 24.5931C124.778 24.3118 125.366 22.6526 125.638 20.4794C123.666 20.9657 122.762 22.4918 122.384 23.142C122.215 23.4343 122.179 24.0899 122.206 24.8162Z"
      fill="#E2915A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M127.219 28.1835C127.219 28.1835 131.516 21.0853 128.174 20.7765C124.833 20.4676 123.489 22.7316 123.006 23.5632C122.523 24.3948 123.132 28.1464 123.132 28.1464L127.219 28.1835Z"
      fill="#FFB27D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M110.838 59.4629C110.97 60.3614 111.239 61.1893 111.57 61.9266C112.62 64.2601 114.307 65.6995 114.307 65.6995H114.309C125.47 60.655 127.729 43.3406 128.108 33.8258C128.26 30.0015 128.108 27.4374 128.108 27.4374C123.072 25.7686 121.656 28.6681 121.656 28.6681C121.656 28.6681 115.712 42.8196 112.629 52.0674C111.449 55.6062 110.688 58.4275 110.838 59.4629Z"
      fill="#B0D0FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M100.35 56.6769C104.073 61.1716 108.941 64.8407 114.307 65.6994H114.309C125.47 60.655 127.729 43.3406 128.108 33.8257C128.108 33.8257 122.825 52.999 115.637 59.7013C114.338 60.9133 112.975 61.7169 111.57 61.9266C111.57 61.9266 102.505 59.3635 100.604 56.9484C100.469 56.774 100.385 56.6879 100.35 56.6769Z"
      fill="#98BAF4"
    />
  </svg>
);

export default Error500Image;
